export const blockIconsCommunicationLiveHelpNew = (
	<span className='material-symbols-outlined'>live_help</span>
);
